import React, {useEffect, useRef, useState} from 'react';
import Swal from "sweetalert2";
import projectUtils from "../../utils/project-utils.js";
import AttachShow from "./attach-show.jsx";
import Button from "../button/button.jsx";
import {FaEye, FaPaperclip} from "react-icons/fa";

const Attach = ({onChangeFile, itemId, removeFile, attachId, attachedFile, showRemove = true, attachedButtonName = "Anexar", attachedButtonDisabled = false, modalTitle = "Anexo"}) => {
    const fileInputRef = useRef(null);
    const [file, setFile] = useState(null);
    const [open, setOpen] = useState(false)
    const [newOpen, setNewOpen] = useState(false)
    const [newFileShow, setNewFileShow] = useState({})

    useEffect(() => onChangeFile(file), [file]);
    useEffect(() => setFile(attachId), [attachId]);

    const attach = () => {
        fileInputRef.current.click();
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file.size > 2000000) {
            projectUtils.swalErrorMessage('', `Tamanho máximo de arquivo excedido. Limite: 2MB`, 'Ok');
            return;
        }

        if (file) {
            const fileType = file.type.split('/');
            const newFile = new File([file], `attach-${itemId}.${fileType[1]}`, {type: file.type});
            setFile(newFile);
            setNewOpen(true)
            setNewFileShow(file)
        }
    }

    const show = () => {
        setOpen(true)
    }

    const remove = () => {
        Swal.fire({
            title: "Excluir",
            text: 'Deseja excluir o anexo?',
            icon: "warning",
            confirmButtonText: "Sim",
            cancelButtonColor: "#c10007",
            cancelButtonText: "Não",
            confirmButtonColor: "#063A6C",
            showCancelButton: true,
            reverseButtons: true,
        }).then(({isConfirmed}) => {
            if (isConfirmed) {
                setFile(null)
                setOpen(false)
                removeFile(file, itemId)
                setNewOpen(false)
                setNewFileShow([])
            }
        });
    }

    return (
        <>
            <input className="hidden" type="file" ref={fileInputRef} onChange={handleFileChange}
                   accept="image/png, image/jpeg, application/pdf"/>

            {
                (!file && !attachId) &&
                <Button target={"attach"} className={"w-full"} onClick={attach} disabled={attachedButtonDisabled}>
                    <FaPaperclip /> {attachedButtonName}
                </Button>
            }

            {
                (file || attachId) &&
                <Button target={"attached"} className={"w-full"} onClick={show}>
                    <FaEye /> Visualizar
                </Button>
            }

            <AttachShow
                open={open}
                setOpen={setOpen}
                remove={remove}
                attachId={attachId}
                newOpen={newOpen}
                newFileShow={newFileShow}
                setNewOpen={setNewOpen}
                showRemove={showRemove}
                modalTitle={modalTitle}
            />

        </>
    );
};

export default Attach;
